export const RESET_CORE_EXPLORE = 'RESET_CORE_EXPLORE';
export const resetCoreExplore = { type: RESET_CORE_EXPLORE };
